import { InvestigacionDTO } from "@DTOS";
import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { Actualizador } from "./Actualizador";
import { InvestigacionesService } from "../../../../servicesBackend/investigaciones.service";
import { AccionEnum } from "@shared/enums";

export class GrupoActualizador extends Actualizador {
    constructor(private investigacionesService: InvestigacionesService) {
        super();
    }

    public async actualizar(
        investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion
    ): Promise<InvestigacionDTO> {
        const investigacionClon = investigacion.clon();
        if (datos.datosGrupo!.accion === AccionEnum.AGREGAR) {
            await this.investigacionesService.agregarGrupo(investigacionClon, datos.datosGrupo!.grupo);
        } else if (datos.datosGrupo!.accion === AccionEnum.ACTUALIZAR) {
            await this.investigacionesService.guardarGrupo(investigacionClon, datos.datosGrupo!.grupo);
        } else if (datos.datosGrupo!.accion === AccionEnum.BORRAR) {
            await this.investigacionesService.eliminarGrupo(investigacionClon, datos.datosGrupo!.grupo);
        }
        return investigacionClon;
    }

    public esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return datos.datosGrupo != null;
    }

}
